import { BaseModel } from "sjs-base-model";
import ProvinciaModel from "./ProvinciaModel";
import ValidationUtility from "../../../utilities/ValidationUtility";
import FunctionEnum from "../../../constants/FunctionEnum";

export default class SimulazioneStepThreeFormModel extends BaseModel {
    public readonly name?: string = "";
    public readonly surname?: string = "";
    public readonly sex?: string = "";
    public readonly birthNation?: string = "";
    public readonly birthPlace: string = "";
    public readonly birthForeignPlace?: string = "";
    public readonly birthCounty?: ProvinciaModel = new ProvinciaModel({});
    public readonly birthDate?: string = "";
    public readonly taxCode?: string = "";
    public readonly residenceNation?: string = "";
    public readonly residencePlace?: string = "";
    public readonly residencePlaceAbroad?: string = "";
    public readonly residenceCounty?: ProvinciaModel = new ProvinciaModel({});
    public readonly residenceAddress?: string = "";
    public readonly residenceCivicNumber?: string = "";
    public readonly mobileNumber?: string = "";
    public readonly email?: string = "";
    public readonly existingExtinctions?: string = "";
    public readonly thirdPartiesYearExtinctions?: string = "2";
    public readonly existingAssignment?: boolean = false;
    public readonly documentoDaCaricare?: string = "";
    public readonly documentoDaFirmare?: string = "";
    public readonly residenceAddressType?: string = "";
    public readonly idEstimate?: number = undefined;
    public readonly sourceDetail: string = "";
    public readonly otp: string = "";
    public readonly idAnag?: number = undefined;
    public readonly typeId?: number = undefined;
    public readonly IdFiliale: string = "";
    public readonly fgTaxCodeForce: boolean = false;

    constructor(data: Partial<SimulazioneStepThreeFormModel>) {
        super();

        this.update(data);
    }
}
